import i18n from 'modules/core/lib/i18n'

const getNameByType = (type: string): string => {
  const descriptions: Record<string, string> = {
    address: i18n.t('bookkeepers.clients.preferences.names.address'),
    bank: i18n.t('bookkeepers.clients.preferences.names.bank'),
    contract: i18n.t('bookkeepers.clients.preferences.names.contract'),
    gender: i18n.t('bookkeepers.clients.preferences.names.gender'),
    hiring: i18n.t('bookkeepers.clients.preferences.names.hiring'),
    id: i18n.t('bookkeepers.clients.preferences.names.id'),
    irpf: i18n.t('bookkeepers.clients.preferences.names.irpf'),
    legal_entity: i18n.t('bookkeepers.clients.preferences.names.legal_entity'),
    name: i18n.t('bookkeepers.clients.preferences.names.name'),
    nationality: i18n.t('bookkeepers.clients.preferences.names.nationality'),
    residence: i18n.t('bookkeepers.clients.preferences.names.residence'),
    termination: i18n.t('bookkeepers.clients.preferences.names.termination'),
    workplace: i18n.t('bookkeepers.clients.preferences.names.workplace'),
    phone_number: i18n.t('bookkeepers.clients.preferences.names.phone_number'),
    tax_id: i18n.t('bookkeepers.clients.preferences.names.tax_id'),
    cost_center: i18n.t('bookkeepers.clients.preferences.names.cost_center'),
    email: i18n.t('bookkeepers.clients.preferences.names.email'),
  }

  return descriptions[type] || type
}

const getDescriptionByType = (type: string): string => {
  const descriptions: Record<string, string> = {
    name: i18n.t('bookkeepers.clients.preferences.types_description.name'),
    id: i18n.t('bookkeepers.clients.preferences.types_description.id'),
    address: i18n.t('bookkeepers.clients.preferences.types_description.address'),
    contract: i18n.t('bookkeepers.clients.preferences.types_description.contract'),
    irpf: i18n.t('bookkeepers.clients.preferences.types_description.irpf'),
    bank: i18n.t('bookkeepers.clients.preferences.types_description.bank'),
    residence: i18n.t('bookkeepers.clients.preferences.types_description.residence'),
    nationality: i18n.t('bookkeepers.clients.preferences.types_description.nationality'),
    gender: i18n.t('bookkeepers.clients.preferences.types_description.gender'),
    hiring: i18n.t('bookkeepers.clients.preferences.types_description.hiring'),
    termination: i18n.t('bookkeepers.clients.preferences.types_description.termination'),
    workplace: i18n.t('bookkeepers.clients.preferences.types_description.workplace'),
    cost_center: i18n.t('bookkeepers.clients.preferences.types_description.cost_center'),
    email: i18n.t('bookkeepers.clients.preferences.types_description.email'),
  }

  return (
    descriptions[type] ||
    i18n.t('bookkeepers.clients.preferences.types_description.other', { type })
  )
}

export const translatedHelpers = (key: string) => ({
  getTranslatedTitle: () => getNameByType(key),
  getTranslatedDescription: () => getDescriptionByType(key),
})
